import React from 'react';
import { Box } from '@chakra-ui/react';
import { useScrollProgress } from '../../hooks/useParallax';

const ScrollProgressBar = () => {
  const progress = useScrollProgress();

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      height="3px"
      bg="rgba(212,168,95,0.08)"
      zIndex="1000"
      pointerEvents="none"
    >
      <Box
        height="100%"
        bg="linear-gradient(90deg, #C99846, #D4A85F, #E0B873)"
        width={`${progress * 100}%`}
        transition="width 0.1s ease-out"
        boxShadow="0 0 10px rgba(212,168,95,0.45)"
      />
    </Box>
  );
};

export default ScrollProgressBar;
